document.addEventListener('DOMContentLoaded', function() {
    var autoPartSearchDiv = document.querySelector('.auto-part-search-bar');
    var button = document.createElement('button');
 
    button.id = 'apsToggleButton';
    button.textContent = 'FIND YOUR VEHICLE';
    button.classList.add('button');

    autoPartSearchDiv.parentNode.insertBefore(button, autoPartSearchDiv);

    button.addEventListener('click', function() {
        if (autoPartSearchDiv.classList.contains('open')) {
            autoPartSearchDiv.classList.remove('open');
        } else {
            autoPartSearchDiv.classList.add('open');
        }
    });
});

 